import { render, staticRenderFns } from "./CampaignHeader.vue?vue&type=template&id=19d7c99f&scoped=true&"
import script from "./CampaignHeader.vue?vue&type=script&lang=js&"
export * from "./CampaignHeader.vue?vue&type=script&lang=js&"
import style0 from "./CampaignHeader.vue?vue&type=style&index=0&id=19d7c99f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d7c99f",
  null
  
)

export default component.exports